import Index from "./components/Index.svelte";

const routes = [
  {
    name : "/:_id",
    component: Index
  },
  {
    name : '/',
    component: Index
  }
]

export { routes }
